<template>
  <div class="home">
    <!-- 主框架 -->
    <el-container style="height: 100%">
      <!-- 左侧模块 -->
      <el-aside
        style="width: 210px"
        height="100%"
        :class="{
          'el-aside-collapse': showUserInfoText,
          'el-aside-no-collapse': !showUserInfoText
        }"
      >
        <menu-left-user-info :show="showUserInfoText" />
        <el-scrollbar class="scrollbarLeftHeight">
          <menu-left
            v-if="menuLeftData.length > 0"
            ref="menuLeftRef"
            :list="menuLeftData"
            :activePath="activePath"
          />
        </el-scrollbar>
      </el-aside>
      <!-- 主体框架 -->
      <el-container style="height: 100%">
        <!-- 头部模块 -->
        <el-header>
          <!-- <span @click="getWarnData" style="cursor: pointer">发送预警信息</span> -->
          <nav-top
            @click-login-out="loginOut"
            @click-reset-pwd="resetpwd"
            @click-fold-icon="clickFoldIcon"
            @click-meteorological-service="meteorologicalService"
            @open-ai="openAiHandle"
            :name="userInfo.userName"
            :unitName="userInfo.companyName"
            :logo="userInfo.logo"
            :userId="userInfo.userId"
            :foldIcon="showUserInfoText ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
          />
        </el-header>
        <!-- 主内容区域 -->
        <el-main ref="elMainRef" width="100%" height="50%" :class="{ mainFull: isFull }">
          <el-header
            class="router-tag-box"
            :style="quickBg ? { background: '#0a263e', color: '#fff' } : {}"
          >
            <router-tag
              @delete-router-list="deleteRouterList"
              @click-full-main="clickFullMain"
              @close-tag="closeTag"
              :list="routerList"
            />
          </el-header>
          <!-- 背景粒子 -->
          <vue-particles
            color="#dedede"
            :particleOpacity="0.7"
            :particlesNumber="80"
            shapeType="circle"
            :particleSize="4"
            linesColor="#dedede"
            :linesWidth="1"
            :lineLinked="true"
            :lineOpacity="0.4"
            :linesDistance="150"
            :moveSpeed="3"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="true"
            clickMode="push"
            style="height: 100%; width: 100%; position: absolute; left: 0; top: 0; z-index: 0"
          />
          <el-scrollbar class="scrollbarHeight" ref="scrollbarRef">
            <router-view v-slot="{ Component }">
              <transition name="fade-transform" mode="out-in">
                <keep-alive include="Home,News">
                  <div v-if="!isRefresh" :include="cachePages" style="padding: 0; height: 100%">
                    <component class="view" :is="Component" />
                  </div>
                </keep-alive>
              </transition>
            </router-view>
          </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
    <!-- 退出登录提示框 -->
    <ml-dialog ref="loginOutDialogRef" content="确定退出登录？" @click-submit="submitLoginOut" />
    <!-- 修改密码对话 框 -->
    <ml-dialog
      width="455px"
      title="修改密码"
      ref="resetPwdDialogRef"
      customClass="reset-pwd-dialog"
      @click-submit="submitResetPwd"
    >
      <template #body>
        <!-- 修改密码表单 -->
        <ml-form
          ref="updateUserPwdRef"
          style="width: 80%"
          labelWidth="100px"
          :model="resetPwdFormData"
          :rules="resetPwdRules"
        >
          <!-- 输入框-原密码 -->
          <ml-input
            prop="password"
            label="原密码"
            prefixIcon="el-icon-unlock"
            placeholder="请输入原密码"
            v-model="resetPwdFormData.password"
            showPassword
          />
          <!-- 输入框-新密码 -->
          <ml-input
            prop="newUserPass"
            label="新密码"
            prefixIcon="el-icon-unlock"
            placeholder="请输入新密码"
            v-model="resetPwdFormData.newUserPass"
            showPassword
          />
          <!-- 输入框-确认新密码 -->
          <ml-input
            prop="againNewPwd"
            label="确认新密码"
            prefixIcon="el-icon-unlock"
            placeholder="请输入确认新密码"
            v-model="resetPwdFormData.againNewPwd"
            showPassword
          />
        </ml-form>
      </template>
    </ml-dialog>
    <DialogAi v-if="showDialogAi" :isFullScreen="isAiFullScreen" />
    <ml-dialog
      width="800px"
      title="预警详情"
      ref="earlyWarningRef"
      :showSubmitBtn="false"
      @click-close="closeEarlyWarning"
    >
      <template #body>
        <div class="warn-dialog-main">
          <div class="warn-dialog-title">
            【{{ warnInfo.warnArea }}{{ warnInfo.warnType }}{{ warnInfo.warnLevel }}预警】
          </div>
          <div class="warn-dialog-dsec">{{ warnInfo.publishOrg }} {{ warnInfo.publishTime }}</div>
          <div class="warn-dialog-icon">
            <img :src="warnIcon" alt="" />
          </div>
          <div class="warn-dialog-dsec">{{ warnInfo.warnContent }}</div>
        </div>
      </template>
    </ml-dialog>
  </div>
</template>

<script>
import { computed, nextTick, onMounted, provide, reactive, ref, watch } from 'vue'
import NavTop from './components/NavTop.vue'
import MenuLeft from './components/MenuLeft.vue'
import MenuLeftUserInfo from './components/MuneLeftUserInfo.vue'
import RouterTag from './components/RouterTag.vue'
// import menuLeftData from './menuLeftData'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { BASEURL, prefix } from '@API'
import { addRouteHandle } from '@/router/index.js'
import DialogAi from '@/components/dialogAi.vue'
import WebSocketPlugin from '@/utils/websocket-plugin'
import { getWebScoketUrl } from '@/utils/index.js'
import bus from '@/utils/bus'


// 预警图标, file: 火警，rain: 下雨，typhoon: 台风

import fire_orange from '@/assets/image/warn/fire_orange.gif'
import fire_red from '@/assets/image/warn/fire_red.gif'
import fire_yellow from '@/assets/image/warn/fire_yellow.gif'
import rain_blue from '@/assets/image/warn/rain_blue.gif'
import rain_orange from '@/assets/image/warn/rain_orange.gif'
import rain_red from '@/assets/image/warn/rain_red.gif'
import rain_yellow from '@/assets/image/warn/rain_yellow.gif'
import typhoon_blue from '@/assets/image/warn/typhoon_blue.gif'
import typhoon_orange from '@/assets/image/warn/typhoon_orange.gif'
import typhoon_red from '@/assets/image/warn/typhoon_red.gif'
import typhoon_yellow from '@/assets/image/warn/typhoon_yellow.gif'
import yujingMp3 from '@/assets/image/warn/yujing.mp3'

// 预警等级
const warnLevel = {
  1: '橙色',
  2: '红色',
  3: '黄色',
  4: '绿色'
}

export default {
  name: 'Home',
  components: {
    NavTop,
    MenuLeft,
    MenuLeftUserInfo,
    RouterTag,
    DialogAi
  },
  setup() {
    const { commit, getters, dispatch } = useStore()
    const router = useRouter()
    const route = useRoute()
    const updateUserPwdRef = ref()
    const scrollbarRef = ref()
    // 设置缓存组件列表
    const cachePages = computed(() => getters.getCachePages)
    const isRefresh = computed(() => getters.getIsRefresh)
    const routerKey = computed(() => route.path)
    const routerList = computed(() => getters.getRouterList)
    const toKen = computed(() => getters.getAccessToken)
    const quickBg = computed(() => getters.getQuickBg)
    const iframeSrc = ref(
      `${BASEURL}${prefix}/v1/meteorological?token=${encodeURIComponent(
        toKen.value
      )}&access_token=${encodeURIComponent(toKen.value)}`
    )
    const activePath = ref(route.meta && route.meta.path ? route.meta.path : route.path)
    const goPath = newvalue => {
      if (newvalue && newvalue.length > 0) {
        const hrefArr = []
        newvalue.map(item => {
          if (item.href) {
            hrefArr.push(item.href)
          }

          if (item.children.length > 0) {
            item.children.map(v => {
              if (v.href) {
                hrefArr.push(v.href)
              }
            })
          }
        })
        if (hrefArr.length > 0) {
          if (routerList.value.length <= 0) {
            router.push({ path: hrefArr[0] })
          }
        } else {
          router.push({ path: '/404' })
        }
        // const { href, children } = newvalue[0]
        // if (href) {
        //   router.push({ path: href })
        // } else if (children && children.length > 0) {
        //   const { href } = children[0]
        //   router.push({ path: href })
        // } else {
        //   router.push({ path: '/404' })
        // }
      } else {
        router.push({ path: '/404' })
      }
    }
    watch(
      () => route.path,
      newvalue => {
        if (newvalue === '/') {
          goPath(menuLeftData.value)
        } else {
          activePath.value = route.meta.path ? route.meta.path : newvalue
        }
      }
    )
    // 获取用户信息
    const userInfo = computed(() => getters.getUser)
    // 菜单
    const menuLeftData = computed(() => getters.getMenuList)
    watch(
      () => menuLeftData.value,
      newvalue => {
        goPath(newvalue)
      }
    )
    /*
     * 退出登录
     */
    // 登出对话框Dom
    const loginOutDialogRef = ref()
    // 显示登出对话框
    const loginOut = () => {
      loginOutDialogRef.value.showDialog = true
    }
    const showUserInfoText = ref(false)
    // 收缩展开左边菜单
    const menuLeftRef = ref()
    const clickFoldIcon = () => {
      showUserInfoText.value = menuLeftRef.value.isCollapse = !menuLeftRef.value.isCollapse
    }
    const meteorologicalService = () => {
      window.open(iframeSrc.value)
    }
    // 确定登出--跳转登录页面
    const submitLoginOut = () => {
      dispatch('fetchLoginOut').then(data => {
        if (data && data.code === 200) {
          // 清除用户信息
          commit('setError', {
            status: true,
            title: data.message,
            message: '正在前往重新登录...',
            type: 'success'
          })
          commit('setLoginOut')
          // router.push({ path: '/login' })
        }
      })
    }
    /*
     * 修改密码
     */
    // 修改密码对话框Dom
    const resetPwdDialogRef = ref()
    // 修改密码表单配置
    const resetPwdFormData = reactive({
      password: '',
      newUserPass: '',
      againNewPwd: ''
    })
    // 显示修改密码对话框
    const resetpwd = () => {
      resetPwdDialogRef.value.showDialog = true
    }
    // 密码强度正则：必须包含大写字母、小写字母、数字和特殊符号，长度8-16位
    const pwdStrengthReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9\s]).{8,16}$/
    // 校验新密码与确认密码是否一致
    const newPwdIsSameAgainPwd = () => {
      return (
        resetPwdFormData.newUserPass &&
        resetPwdFormData.againNewPwd &&
        resetPwdFormData.newUserPass === resetPwdFormData.againNewPwd
      )
    }
    // 校验新密码强度
    const validateNewPwdStrength = (rule, value, callback) => {
      if (!value) {
        callback()
      } else if (!pwdStrengthReg.test(value)) {
        callback(new Error('必须包含大小写字母、数字和特殊符号，且长度为8-16位'))
      } else {
        callback()
      }
    }
    // 修改密码校验
    const resetPwdRules = {
      password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
      newUserPass: [
        { required: true, message: '请输入新密码', trigger: 'blur' },
        { validator: validateNewPwdStrength, trigger: 'blur' },
        { validator: newPwdIsSameAgainPwd, message: '新密码与确认新密码不一致', trigger: 'blur' }
      ],
      againNewPwd: [
        { required: true, message: '请输入确认新密码', trigger: 'blur' },
        { validator: validateNewPwdStrength, trigger: 'blur' },
        { validator: newPwdIsSameAgainPwd, message: '新密码与确认新密码不一致', trigger: 'blur' }
      ]
    }
    // 确认修改密码
    const submitResetPwd = () => {
      updateUserPwdRef.value.CustomFormRef.validate()
        .then(() => {
          const { password, newUserPass } = resetPwdFormData
          dispatch('fetchUpdateUserPass', { password, newUserPass }).then(data => {
            // 确定修改密码
            if (data && data.code === 200) {
              commit('setError', {
                status: true,
                title: data.message,
                message: '正在前往重新登录...',
                type: 'success'
              })
              // 清除用户信息
              commit('setLoginOut')
              router.push({ path: '/login' })
            }
          })

          // console.log(true)
        })
        .catch(() => {})
    }

    // 全屏
    const isFull = ref(false)
    const clickFullMain = () => {
      if (isFull.value) {
        isFull.value = false
      } else {
        isFull.value = true
      }
    }
    // 关闭快捷路由
    const closeTag = async index => {
      if (index >= 0 && route.name === routerList.value[index].name) {
        let path = ''
        if (routerList.value[index + 1]) {
          path = routerList.value[index + 1].path
        } else {
          path = routerList.value[index - 1].path
        }
        await router.push(path)
      }
      await commit('setRouterList', {
        data: { name: routerList.value[index].name },
        isRemove: true
      })
    }
    // 清除所有路由快捷
    const deleteRouterList = () => {
      const oneData = routerList.value.filter(item => item.path === route.path)
      commit('setRouterListAll', oneData)
    }
    provide('isFull', isFull)

    provide('scrollbar-ref', () => scrollbarRef.value)

    const showDialogAi = ref(false)
    const isAiFullScreen = ref(false)
    const openAiHandle = () => {
      isAiFullScreen.value = false
      showDialogAi.value = true
      console.log('openAiHandle', isAiFullScreen.value, showDialogAi.value)
    }

    const earlyWarningRef = ref(null)
    const socket = ref(null)
    const earlyWarningHandle = () => {
      earlyWarningRef.value.showDialog = true
      bus.emit('playAudio')
    }
    const initWebSocket = () => {
      const webSocketUrl = getWebScoketUrl() || 'ws://10.200.3.56:26395'
      socket.value = new WebSocketPlugin({
        url: `${webSocketUrl}/dseWeb/websocket/${userInfo.value.userCode}`,
        heartbeatInterval: 3000
      })
      socket.value.on('message', data => {
        console.log('Received message:', data)
        if (data) {
          receiveMessage(JSON.parse(data))
        }
      })
    }
    const iconMap = {
      雨: {
        红色: rain_red,
        橙色: rain_orange,
        黄色: rain_yellow,
        蓝色: rain_blue
      },
      台风: {
        红色: typhoon_red,
        橙色: typhoon_orange,
        黄色: typhoon_yellow,
        蓝色: typhoon_blue
      }
    }
    const warnIcon = ref('')
    // 预警图标
    const getWarnIcon = () => {
      const { warnType, warnLevel } = warnInfo.value
      const typeKey = Object.keys(iconMap).find(key => warnType.includes(key))
      const levelKey = ['红色', '橙色', '黄色', '蓝色'].find(level => warnLevel.includes(level))
      if (typeKey && levelKey) {
        earlyWarningHandle()
        return iconMap[typeKey][levelKey]
      } else {
        return ''
      }
    }
    const receiveMessage = data => {
      warnInfo.value = data
      console.log(data)
      if (warnInfo.value.warnId) {
        warnIcon.value = getWarnIcon()
      }
    }
    const warnInfo = ref({})
    const closeEarlyWarning = () => {
      bus.emit('pauseAudio')
      earlyWarningRef.value.showDialog = false
    }

    const getWarnData = () => {
      let warnId = new Date().getTime()

      dispatch('fetchSendWeatherWarn', {
        queryTime: '2025-08-07 08:00',
        warnList: [
          {
            warnId: warnId + '',
            warnType: '台风',
            warnStatus: '发布',
            warnLevel: '红色',
            publishTime: '2025-08-07 08:00',
            publishOrg: '台山市气象台',
            warnAreaCode: '440781',
            warnArea: '台山市',
            warnContent:
              '【台山雷雨大风黄色预警】预计未来6小时，我市有雷暴、短时强降水和短时大风等强对流天气，台山市气象台8月7日8时发布雷雨大风黄色预警信号，请注意防御。'
          }
        ]
      })
    }

    onMounted(async () => {
      initWebSocket()
      if (route.path === '/') {
        if (menuLeftData.value[0].children && menuLeftData.value[0].children.length > 0) {
          router.push({ path: menuLeftData.value[0].children[0].href })
          activePath.value = menuLeftData.value[0].children[0].href
        } else {
          router.push({ path: menuLeftData.value[0].href })
          activePath.value = menuLeftData.value[0].href
        }
      } else {
        activePath.value = route.meta.path || route.path
      }
      window.addEventListener('message', event => {
        let data = event.data
        if (data.type === 'close') {
          showDialogAi.value = false
        } else if (data.type === 'fullScreen') {
          // 全屏和退出全屏
          isAiFullScreen.value = data.data.isFullScreen
        }
      })

      // await dispatch('fetchGetUserModuleTreeList', { parentId: 0 }).then(data => {
      //   if (data && data.code === 200) {
      //     const superAdmin = {
      //       title: ' 运维态势',
      //       field: 'super_admin',
      //       icon: 'el-icon-s-grid',
      //       href: '/superAdmin',
      //       children: []
      //     }
      //     const amoebaHead = {
      //       title: ' 运维态势',
      //       field: 'super_admin',
      //       icon: 'el-icon-s-grid',
      //       href: '/amoebaHead',
      //       children: []
      //     }
      //     addRouteHandle(data.data)
      //     const nData = data.data.map(item => {
      //       if (item.href === '/superAdmin') {
      //         if (userInfo.value.userType === 'division_manager') {
      //           return superAdmin
      //         } else {
      //           return amoebaHead
      //         }
      //       } else {
      //         return item
      //       }
      //     })
      //     commit('setMenuLeft', [...nData])
      //     if (route.path === '/' && data.data[0].children && data.data[0].children.length > 0) {
      //       router.push({ path: data.data[0].children[0].href })
      //       activePath.value = data.data[0].children[0].href
      //     } else {
      //       activePath.value = route.meta.path || route.path
      //     }
      //     console.log(788, activePath)
      //   }
      // })
      await dispatch('fetchGetCityAreaTrees').then(data => {
        if (data && data.code === 200) {
          const nData = data.data || []
          if (nData.length > 0) {
            // commit('setArea', [{ code: 0, name: '全部', children: nData }])
            commit('setArea', nData)
          }
        }
      })
    })

    return {
      updateUserPwdRef,
      activePath,
      userInfo,
      loginOutDialogRef,
      loginOut,
      submitLoginOut,
      menuLeftData,
      resetPwdDialogRef,
      resetpwd,
      submitResetPwd,
      resetPwdFormData,
      resetPwdRules,
      clickFoldIcon,
      meteorologicalService,
      menuLeftRef,
      showUserInfoText,
      clickFullMain,
      isFull,
      cachePages,
      isRefresh,
      routerKey,
      routerList,
      quickBg,
      closeTag,
      deleteRouterList,
      scrollbarRef,
      showDialogAi,
      openAiHandle,
      isAiFullScreen,
      earlyWarningRef,
      getWarnData,
      warnInfo,
      warnIcon,
      closeEarlyWarning
    }
  }
}
</script>

<style lang="scss">
.home {
  height: 100%;
  .el-header {
    height: 50px !important;
    padding: 0;
    line-height: 50px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
    z-index: 2;
  }
  body > .el-container {
    margin-bottom: 40px;
  }
  .el-aside {
    transition: all 0.3s;
  }
  .el-aside-collapse {
    width: 64px !important;
  }
  .router-tag-box {
    z-index: 1;
    height: 35px !important;
    line-height: 35px;
    background-color: #fff;
    position: relative;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
    // margin-bottom: 20px;
  }
  .el-main {
    background-color: #eff1f4;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
    padding: 0;
    // height: calc(100vh - 50px);
    height: calc(100vh);
    overflow: hidden;
    position: relative;
    transition: all 0.3s;
  }
  // 全屏情况
  .mainFull {
    .scrollbarHeight {
      height: calc(100vh - 35px) !important;
    }
  }
  .scrollbarHeight {
    height: calc(100vh - 70px);
    // height: 100%;
  }
  .scrollbarLeftHeight {
    height: calc(100vh - 50px);
  }
}
.warn-dialog-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px;
  .warn-dialog-title {
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }
  .warn-dialog-dsec {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    margin-top: 16px;
  }
  .warn-dialog-icon {
    margin-top: 24px;
    width: 250px;
    height: 202px;
  }
}
.warn-dialog-audio {
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
}
/* 修改密码弹窗表单项下边距 */
.reset-pwd-dialog .el-form-item {
  margin-bottom: 32px;
}
</style>
